/**
 * Product Featured Image Module
 * Handles thumbnail gallery with main image display
 */

export function initProductFeatured() {
  const featuredWraps = document.querySelectorAll('.product-featured-wrap');

  if (featuredWraps.length === 0) {
    console.log('No product featured wraps found');
    return;
  }

  featuredWraps.forEach((wrap, index) => {
    initFeaturedGallery(wrap, index);
  });

  console.log(`✅ Product featured initialized for ${featuredWraps.length} galleries`);
}

function initFeaturedGallery(wrap, index) {
  const thumbsContainer = wrap.querySelector('.featured-thumbs .inner');
  const mainImage = wrap.querySelector('.featured-image .featured-image-img');
  const moreBtn = wrap.querySelector('.featured-thumbs .more');

  if (!thumbsContainer || !mainImage) {
    console.warn(`Featured gallery #${index + 1}: Missing required elements`);
    return;
  }

  const thumbItems = thumbsContainer.querySelectorAll('.item');

  if (thumbItems.length === 0) {
    console.warn(`Featured gallery #${index + 1}: No thumbnail items found`);
    return;
  }

  let isExpanded = false;
  const VISIBLE_COUNT = 3;
  const hasMoreItems = thumbItems.length > VISIBLE_COUNT;

  // Hide more button if 3 or fewer thumbnails
  if (moreBtn && !hasMoreItems) {
    moreBtn.style.display = 'none';
  }

  // Initialize first thumbnail as active
  if (thumbItems.length > 0) {
    thumbItems[0].classList.add('is-active');
  }

  // Thumbnail click handler
  thumbItems.forEach((thumb, thumbIndex) => {
    thumb.addEventListener('click', () => {
      const largeImageUrl = thumb.dataset.largeImage;

      if (!largeImageUrl) {
        console.warn(`Thumbnail #${thumbIndex + 1}: No data-large-image attribute found`);
        return;
      }

      // Update active state
      thumbItems.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      // Update main image with fade effect
      mainImage.classList.add('is-loading');

      const newImage = new Image();
      newImage.onload = () => {
        mainImage.src = largeImageUrl;
        mainImage.classList.remove('is-loading');
      };
      newImage.onerror = () => {
        console.error(`Failed to load image: ${largeImageUrl}`);
        mainImage.classList.remove('is-loading');
      };
      newImage.src = largeImageUrl;

      // Scroll thumbnail into view if expanded
      if (isExpanded) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });

  // More/Less button handler
  if (moreBtn && hasMoreItems) {
    moreBtn.addEventListener('click', () => {
      isExpanded = !isExpanded;

      if (isExpanded) {
        thumbsContainer.classList.add('is-expanded');
        moreBtn.classList.add('is-expanded');
        moreBtn.textContent = 'Tutup';

        // Scroll to active thumbnail
        const activeThumb = thumbsContainer.querySelector('.item.is-active');
        if (activeThumb) {
          setTimeout(() => {
            activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 100);
        }
      } else {
        thumbsContainer.classList.remove('is-expanded');
        moreBtn.classList.remove('is-expanded');
        moreBtn.textContent = 'Lihat Lebih';
      }
    });
  }
}
